module.exports = __webpack_public_path__ + "static/img/heart.3892e355.svg";